// determine whether the code is being run in the browser or on the server
var isServer = function () { var _a; return typeof process !== 'undefined' && typeof ((_a = process === null || process === void 0 ? void 0 : process.versions) === null || _a === void 0 ? void 0 : _a.node) !== 'undefined'; };

export { isServer };
//# sourceMappingURL=misc.esm.js.map
